import { render, staticRenderFns } from "./OtpForm.vue?vue&type=template&id=149ce387&scoped=true"
import script from "./OtpForm.vue?vue&type=script&lang=js"
export * from "./OtpForm.vue?vue&type=script&lang=js"
import style0 from "./OtpForm.vue?vue&type=style&index=0&id=149ce387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ce387",
  null
  
)

export default component.exports